import { Workbox } from 'workbox-window'

let wb: Workbox | undefined

export function getWorkboxInstance(): Workbox | undefined {
  return wb
}

export function setWorkboxInstance(newWb: Workbox) {
  wb = newWb
}
